


















import './KisweButtonFilePicker.scss'
import { defineComponent, ref } from '@vue/composition-api'
import KisweButton from '../KisweButton'

export default defineComponent({
  name: 'KisweButtonFilePicker',
  components: {
    KisweButton
  },
  inheritAttrs: false,
  props: {
    accept: {
      type: String,
      required: false,
      default: ''
    },
    multiple: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: {
    change (_files: FileList) { return true }
  },
  setup (_props, { emit }) {
    const fileInput = ref<HTMLInputElement|null>(null)

    const pickFile = () => {
      if (!fileInput.value) return
      fileInput.value.value = ''
      fileInput.value.click()
    }

    const selectedFiles = () => {
      if (!fileInput.value) return
      const files = fileInput.value.files
      if (!files || files.length === 0) {
        console.warn('No file selected')
        return
      }
      emit('change', files)
    }

    return {
      fileInput,
      pickFile,
      selectedFiles
    }
  }
})
